import { Download } from "@mui/icons-material";
import { Button, Grid, IconButton, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import LoadingAnimation from "../../../Components/LottieAnimation/LoadingAnimation";

const InstallerDocs = () => {
    const { docs, isLodaing } = useSelector((state) => state.installer);
    const DOCS = docs?.data?.Docs;
    return (
        <>
            {isLodaing && <LoadingAnimation />}
            {!isLodaing && (
                <>
                    {DOCS?.map((doc, index) => (
                        <Grid
                            key={index}
                            container
                            columns={12}
                            spacing={2}
                            mt={3}
                        >
                            <Grid item xs={6} sx={{ padding: "25px" }}>
                                <Typography variant="span">
                                    {" "}
                                    Agreement Path :{" "}
                                </Typography>
                                {!doc.file.agreement_path ? (
                                    "null"
                                ) : (
                                    <IconButton>
                                        <a
                                            href={doc?.file?.agreement_path}
                                            download
                                            rel="noopener noreferrer"
                                            target="_blank"
                                        >
                                            <Download color="primary" />
                                        </a>
                                    </IconButton>
                                )}
                            </Grid>
                            <Grid item xs={6} sx={{ padding: "25px" }}>
                                <Typography variant="span">APCR :</Typography>
                                {!doc.file.apcr_path ? (
                                    "null"
                                ) : (
                                    <IconButton>
                                        <a
                                            href={doc?.file?.apcr_path}
                                            download
                                            rel="noopener noreferrer"
                                            target="_blank"
                                        >
                                            <Download color="primary" />
                                        </a>
                                    </IconButton>
                                )}
                            </Grid>
                            <Grid item xs={6} sx={{ padding: "25px" }}>
                                <Typography variant="span"> NDA :</Typography>
                                {!doc.file.nda_path ? (
                                    "null"
                                ) : (
                                    <IconButton>
                                        <a
                                            href={doc?.file?.nda_path}
                                            download
                                            rel="noopener noreferrer"
                                            target="_blank"
                                        >
                                            <Download color="primary" />
                                        </a>
                                    </IconButton>
                                )}
                            </Grid>
                        </Grid>
                    ))}
                </>
            )}
        </>
    );
};

export default InstallerDocs;
